import React, { useState, useEffect } from 'react'
import { useNavigation } from '@react-navigation/native'
import { find_color, useTheme } from '../context/HeaderContext'

export const useSetColor = (name) => {
    const navigation = useNavigation()
    const { setAppBackgroundColor, setResetBackgroundColor } = useTheme()
    const [isLoading, setIsLoading] = useState(true)

    useEffect(() => {
        const unsubscribeFocus = navigation.addListener('focus', () => {
            setAppBackgroundColor(find_color(name));
            setIsLoading(false)
        });

        const unsubscribeBlur = navigation.addListener('blur', () => {
            setResetBackgroundColor()

        });

        return () => {
            unsubscribeFocus();
            unsubscribeBlur();
        }

    }, [navigation, name])

    return {
        isLoading
    }
}
